module.exports = __webpack_public_path__ + "img/page13.600bcabc.png";